import { ChevronDown, MessageCircle, TrendingUp } from "lucide-react"
import { COMMUNITY_CHANNELS } from "../../community/community-service"

const channelIcons = {
  general: MessageCircle,
  profitloss: TrendingUp,
}

const channelLabels = {
  general: "General",
  profitloss: "Profit & Loss",
}

export default function CommunityChannelSidebar({
  activeChannel,
  onSelectChannel,
  onMobileHeaderClick,
  className,
}) {
  const headerContent = (
    <>
      {onMobileHeaderClick != null ? (
        <ChevronDown
          className="h-4 w-4 shrink-0 text-gray-400 lg:hidden"
          aria-hidden
        />
      ) : null}
      <span className="text-xs font-semibold uppercase tracking-wider text-gray-400">
        Channels
      </span>
    </>
  )

  return (
    <aside
      className={className}
    >
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-2 px-2 py-1">
          {onMobileHeaderClick != null ? (
            <button
              type="button"
              onClick={onMobileHeaderClick}
              className="flex items-center gap-1.5 -mx-1 -my-0.5 px-1 py-0.5 rounded text-left hover:bg-gray-800/50 transition-colors lg:pointer-events-none lg:cursor-default lg:hover:bg-transparent"
              aria-label="Hide channels"
            >
              {headerContent}
            </button>
          ) : (
            <p className="shrink-0">{headerContent}</p>
          )}
        </div>

        <button
          type="button"
          onClick={() => onSelectChannel(null)}
          className={[
            "flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm font-medium transition-colors",
            activeChannel === null
              ? "bg-emerald-500/15 text-emerald-300"
              : "text-gray-400 hover:bg-gray-800/40 hover:text-white",
          ].join(" ")}
        >
          <MessageCircle
            className={[
              "h-4 w-4 shrink-0",
              activeChannel === null ? "text-emerald-300" : "text-gray-500",
            ].join(" ")}
          />
          All
        </button>

        {COMMUNITY_CHANNELS.map((ch) => {
          const Icon = channelIcons[ch]
          const isActive = activeChannel === ch
          const pill =
            ch === "profitloss"
              ? {
                  active: "bg-blue-500/15 text-blue-200",
                  icon: "text-blue-200",
                }
              : {
                  active: "bg-emerald-500/15 text-emerald-300",
                  icon: "text-emerald-300",
                }

          return (
            <button
              key={ch}
              type="button"
              onClick={() => onSelectChannel(ch)}
              className={[
                "flex items-center gap-2 rounded-md px-3 py-2 text-left text-sm font-medium transition-colors",
                isActive ? pill.active : "text-gray-400 hover:bg-gray-800/40 hover:text-white",
              ].join(" ")}
            >
              <Icon className={["h-4 w-4 shrink-0", isActive ? pill.icon : "text-gray-500"].join(" ")} />
              {channelLabels[ch]}
            </button>
          )
        })}
      </div>
    </aside>
  )
}

